// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/kubernetes/v1/resourcequantities.proto (package chalk.kubernetes.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/kubernetes/v1/resourcequantities.proto.
 */
export const file_chalk_kubernetes_v1_resourcequantities: GenFile = /*@__PURE__*/
  fileDesc("CixjaGFsay9rdWJlcm5ldGVzL3YxL3Jlc291cmNlcXVhbnRpdGllcy5wcm90bxITY2hhbGsua3ViZXJuZXRlcy52MSI6ChxLdWJlcm5ldGVzUmVzb3VyY2VRdWFudGl0aWVzEhEKBHBvZHMYASABKAVIAIgBAUIHCgVfcG9kc0IcWhprdWJlcm5ldGVzL3YxO2t1YmVybmV0ZXN2MWIGcHJvdG8z");

/**
 * By default it is annoying to parse resource specifications returned by the k8s go api,
 * probably due to go's conspicuous lack of unions.
 * The message creator should do some parsing to return sensible types.
 * Evidently, this type does not reflect all possibilities for a ResourceQuota and should be added to as required.
 *
 * @generated from message chalk.kubernetes.v1.KubernetesResourceQuantities
 */
export type KubernetesResourceQuantities = Message<"chalk.kubernetes.v1.KubernetesResourceQuantities"> & {
  /**
   * @generated from field: optional int32 pods = 1;
   */
  pods?: number;
};

/**
 * Describes the message chalk.kubernetes.v1.KubernetesResourceQuantities.
 * Use `create(KubernetesResourceQuantitiesSchema)` to create a new message.
 */
export const KubernetesResourceQuantitiesSchema: GenMessage<KubernetesResourceQuantities> = /*@__PURE__*/
  messageDesc(file_chalk_kubernetes_v1_resourcequantities, 0);

